module.exports = __webpack_public_path__ + "media/images/rename-dark-ba2183a6475862962ac2b69899bd1725.svg";